import jsPDF from "jspdf";
import api from "../../services/api";
import { obterIdTenent } from "../../services/seguranca";

export const abrirPdfNoVisualizador = (pdf: jsPDF, id: string) => {
    const url = URL.createObjectURL(pdf.output("blob"));
    localStorage.setItem(`pdfURL_${id}`, url);
    window.open(`/pdf-viewer?id=${id}`, "_blank");
};

export const carregarImagem = (url: string): Promise<HTMLImageElement | null> =>
    new Promise((resolve) => {
        if (!url) {
            resolve(null);
            return;
        }
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = () => resolve(null);
        img.src = url;
    });

export const carregarLogoDaEmpresa = async (token: string): Promise<HTMLImageElement | null> => {
    try {
        const response = await api.get(`Empresa/ObterURLLogo/${obterIdTenent(token)}`);
        return await carregarImagem(response.data);
    } catch {
        return null;
    }
};

export const emLotesDe = async <T, R>(itens: T[], tamanho: number, executar: (item: T) => Promise<R>): Promise<R[]> => {
    const resultados: R[] = [];
    for (let i = 0; i < itens.length; i += tamanho) {
        const parte = await Promise.all(itens.slice(i, i + tamanho).map(executar));
        resultados.push(...parte);
    }
    return resultados;
};
